export const STORE_IDS = {
  production: ['CKL89999', 'CKL89998', '99974', 'CKL47948'],
  testbed: ['BCC10000KUL', 'SWK50034', '99974', 'CKL47948']
};

export const MATERIAL_CODES = {
  'Softpin': {
    'RM5': ['ITM-00037'],
    'RM10': ['ITM-00038'],
    'RM20': ['ITM-00039'],
    'RM30': ['ITM-00040'],
    'RM50': ['ITM-00041'],
    'RM100': ['ITM-00042']
  },
  'Reload': {
    'RM5': ['20009618'],
    'RM10': ['20009620'],
    'RM30': ['20013827'],
    'RM50': ['20013828']
  },
  'Prepaid': {
    'Blank Sim': ['20012802', '20015621', '20012352', '20015387']
  },
  'Starter Pack': {
    'RM5': ['20015520', '20013225'],
    'RM10': ['20015622', '20015519', '20013188'],
    'RM30': ['20011545'],
    // 'Others': ['']
  },
};

export const getMaterialCodeSuggestions = (section, item) => {
  return MATERIAL_CODES[section]?.[item] || [];
};

export const getStoreIdSuggestions = (environment) => {
  if (!environment) return [];
  return STORE_IDS[environment] || [];
};

export const handleInputChange = (event, section, item, formData, setFormData) => {
  let name, value;
  if (event && event.target) {
    ({ name, value } = event.target);
  } else {
    name = item;
    value = event;
  }
  console.log(`Section: ${section}, Item: ${item}, Field: ${name}, Value: ${value}`);

  setFormData(prevData => {
    const updatedData = {
      ...prevData,
      [section]: {
        ...prevData[section],
        [item]: section === 'general' ? value : { 
          ...prevData[section][item], 
          [name]: value 
        }
      }
    };
    
    // Debug log for warnings
    if (name === 'store_id_warning' || name === 'material_code_warning') {
      console.log('Setting warning:', section, item, name, value);
      console.log('Updated form state for warnings:', updatedData[section][item]);
    }
    return updatedData;
  });
};

export const validateCustomInput = (value, type, environment, section, item) => {
  if (!value) return false;

  if (type === 'store_id') {
    const predefinedOptions = getStoreIdSuggestions(environment);
    return !predefinedOptions.includes(value);
  } else if (type === 'material_code') {
    // For material code validation
    const predefinedOptions = getMaterialCodeSuggestions(section, item);
    return !predefinedOptions.includes(value);
  }
  
  return false;
};

export const validateCustomMaterialCode = (value, section, item) => {
  if (!value) return false;
  
  const predefinedOptions = getMaterialCodeSuggestions(section, item);
  return !predefinedOptions.includes(value);
};

export const clearFormData = (formData, setFormData) => {
  // Always clear all fields except Blank Sim when Blank Sim is active
  setFormData(prevData => {
    const updatedData = { ...prevData };
    
    // Determine which sections are active
    const isBlankSimActive = updatedData?.Prepaid?.['Blank Sim']?.store_id || updatedData?.Prepaid?.['Blank Sim']?.quantity;
    
    // If Blank Sim is active, clear everything else in both production and testbed
    if (isBlankSimActive) {
      return {
        ...updatedData,
        Prepaid: {
          'MSISDN': { store_id: "", material_code: "", quantity: "" },
          'Blank Sim': updatedData.Prepaid['Blank Sim']
        },
        'Starter Pack': {
          'RM5': { store_id: "", material_code: "", quantity: "" },
          'RM10': { store_id: "", material_code: "", quantity: "" },
          'RM30': { store_id: "", material_code: "", quantity: "" },
          'Others': { store_id: "", material_code: "", quantity: "" }
        },
        'Softpin': {
          'RM5': { store_id: "", material_code: "", quantity: "" },
          'RM10': { store_id: "", material_code: "", quantity: "" },
          'RM20': { store_id: "", material_code: "", quantity: "" },
          'RM30': { store_id: "", material_code: "", quantity: "" },
          'RM50': { store_id: "", material_code: "", quantity: "" },
          'RM100': { store_id: "", material_code: "", quantity: "" }
        },
        'Reload': {
          'RM5': { store_id: "", material_code: "", quantity: "" },
          'RM10': { store_id: "", material_code: "", quantity: "" },
          'RM30': { store_id: "", material_code: "", quantity: "" },
          'RM50': { store_id: "", material_code: "", quantity: "" },
          'RM100': { store_id: "", material_code: "", quantity: "" }
        }
      };
    }
    
    // Handle other cases in testbed environment - mutual exclusivity
    if (prevData.general.environment === 'testbed') {
      const isMSISDNActive = updatedData?.Prepaid?.['MSISDN']?.store_id || updatedData?.Prepaid?.['MSISDN']?.quantity;
      const isStarterpackActive = Object.values(updatedData?.['Starter Pack'] || {}).some(item => item.store_id || item.quantity);
      const isSoftpinActive = Object.values(updatedData?.['Softpin'] || {}).some(item => item.store_id || item.quantity);
      
      // If MSISDN is active, clear everything else
      if (isMSISDNActive) {
        return {
          ...updatedData,
          Prepaid: {
            'MSISDN': updatedData.Prepaid['MSISDN'],
            'Blank Sim': { store_id: "", material_code: "", quantity: "" }
          },
          'Starter Pack': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'Others': { store_id: "", material_code: "", quantity: "" }
          },
          'Softpin': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM20': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'RM50': { store_id: "", material_code: "", quantity: "" },
            'RM100': { store_id: "", material_code: "", quantity: "" }
          },
          'Reload': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'RM50': { store_id: "", material_code: "", quantity: "" },
            'RM100': { store_id: "", material_code: "", quantity: "" }
          }
        };
      }
      
      // If Starter Pack is active, clear everything else
      if (isStarterpackActive) {
        return {
          ...updatedData,
          Prepaid: {
            'MSISDN': { store_id: "", material_code: "", quantity: "" },
            'Blank Sim': { store_id: "", material_code: "", quantity: "" }
          },
          'Starter Pack': updatedData['Starter Pack'],
          'Softpin': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM20': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'RM50': { store_id: "", material_code: "", quantity: "" },
            'RM100': { store_id: "", material_code: "", quantity: "" }
          },
          'Reload': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'RM50': { store_id: "", material_code: "", quantity: "" },
            'RM100': { store_id: "", material_code: "", quantity: "" }
          }
        };
      }
      
      // If Softpin is active, clear everything else
      if (isSoftpinActive) {
        return {
          ...updatedData,
          Prepaid: {
            'MSISDN': { store_id: "", material_code: "", quantity: "" },
            'Blank Sim': { store_id: "", material_code: "", quantity: "" }
          },
          'Starter Pack': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'Others': { store_id: "", material_code: "", quantity: "" }
          },
          'Softpin': updatedData['Softpin'],
          'Reload': {
            'RM5': { store_id: "", material_code: "", quantity: "" },
            'RM10': { store_id: "", material_code: "", quantity: "" },
            'RM30': { store_id: "", material_code: "", quantity: "" },
            'RM50': { store_id: "", material_code: "", quantity: "" },
            'RM100': { store_id: "", material_code: "", quantity: "" }
          }
        };
      }
    }
    // If no special case matched, return the original data
    return updatedData;
  });
};